var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{style:({
      padding: _vm.$vuetify.breakpoint.mobile ? undefined : '0px 120px 0px 120px',
    })},[_c('QuestionForm',{attrs:{"config":false,"webform_theme":_vm.webform_theme}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }